<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="header-text">Invite New User</h3>
        <p class="mb-4 text-left text-body-color">
          Enter an email address to invite a new user to your account.
        </p>
        <form-field
          label="Email"
          :value="email"
          placeholder="Enter Email Address"
          :on-input="onInput"
          name="email"
        />
        <div class="mt-4">
          <label class="text-xs font-bold uppercase"
            >Permissions (Optional)</label
          >
          <div
            v-for="box in checkboxes"
            :key="box.key"
          >
            <Checkbox
              :item="box.label"
              :active-val="permissions[box.key]"
              :handle-select="(value) => updatePermission(box.key, value)"
            />
          </div>
        </div>
        <div
          class="flex w-full flex-col md:flex-row md:flex-row-reverse md:gap-x-2"
        >
          <button-main
            :disabled="errors.email"
            @click="sendInvitation"
          >
            Send Invite
          </button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Cancel
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import FormField from '@/components/FormField.vue';
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import { isEmail } from '@/common/validators';
import WordTools from '@/mixins/wordTools';
import Checkbox from '@/components/CheckboxButton.vue';

export default {
  name: 'UserRequestModal',
  components: {
    Modal,
    ButtonMain,
    FormField,
    Checkbox,
  },
  mixins: [WordTools],
  props: {
    visible: Boolean,
    type: String,
  },
  emits: ['close', 'invitation-sent'],
  data() {
    return {
      user: {
        email: '',
        role: '',
      },
      roles: ['Owner', 'Billing'], // fix temp roles
      errors: {
        select: true,
        email: true,
      },
      permissions: {
        manage_users: false,
        driver: false,
      },
    };
  },
  computed: {
    checkboxes() {
      return [
        { key: 'manage_users', label: 'Manage Users' },
        { key: 'driver', label: 'Driver' },
      ];
    },
    errorsExist() {
      return Object.values(this.errors).some((el) => el);
    },
  },
  methods: {
    updatePermission(key, value) {
      this.permissions[key] = value;
    },
    onInput(e) {
      this.user[e.target.name] = e.target.value;
      this.errors.email = !isEmail(e.target.value) && !!e.target.value.length;
    },
    handleSelect(e) {
      if (e !== 'Select User Role') {
        this.errors.select = false;
        this.user.role = e;
      }
    },
    async sendInvitation() {
      if (!isEmail(this.user.email)) return;

      let scopes = [];

      if (this.permissions.manage_users) {
        scopes.push('manage_users');
      }
      if (this.permissions.driver) {
        scopes.push('driver');
      }

      const payload = {
        email: this.user.email,
        scopes: scopes,
        site: 'highway.com',
      };
      const res = await this.$store.dispatch(
        'userInvitations/createUserInvitation',
        payload
      );
      this.$emit('invitation-sent', res);
    },
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-4 text-dark-blue;
}
</style>
